import { typeof as _typeof, objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { PreferenceSource } from './constants.js';
import { ModuleConfig } from '../utility/module.js';

var defaultOptions = {
  preferenceStoreProvider: null
};
var config = new ModuleConfig(defaultOptions);
var source = PreferenceSource.None;
var sourceOptions = {};
var defaults = {};
/**
 * Gets current configuration options for the preferences module
 * @returns {object} Preference module options
 */

var getPreferenceModuleOptions = function getPreferenceModuleOptions() {
  return config.getAll();
};
/**
 * Configures options for the preferences module
 * @param {object} options Options to set
 * @param {object} options.preferenceStoreProvider Instance of a store provider for getting/setting preferences via device storage
 */


var setPreferenceModuleOptions = function setPreferenceModuleOptions(options) {
  if (options.preferenceStoreProvider !== undefined && _typeof(options.preferenceStoreProvider) !== "object") {
    console.warn("Unable to set default preference store provider, provider is invalid");
  }

  config.setAll(options);
};

var getPreferenceSource = function getPreferenceSource() {
  return source;
};

var getPreferenceSourceOptions = function getPreferenceSourceOptions() {
  return _objectSpread2({}, sourceOptions);
};

var getPreferenceDefaults = function getPreferenceDefaults() {
  return _objectSpread2({}, defaults);
};
/**
 * Sets default preference values that will be used initially, or when preferences are reset
 * @param {object} values Default values to set
 */


var setPreferenceDefaults = function setPreferenceDefaults(values) {
  defaults = _objectSpread2({}, values);
};
/**
 * Configures preferences to be saved and loaded from device's local storage
 * @param {string} key storage key for where to store the data
 */


var enablePreferencesFromDeviceStorage = function enablePreferencesFromDeviceStorage(key) {
  source = PreferenceSource.DeviceStorage;
  sourceOptions = {
    key: key
  };
};
/**
 * Configures preferences to be saved and loaded from an external API
 * @param {function} loadAction API action creator for loading preferences data
 * @param {function} saveAction API action creator for saving preferences data
 */


var enablePreferencesFromApi = function enablePreferencesFromApi(loadAction, saveAction) {
  source = PreferenceSource.Api;
  sourceOptions = {
    loadAction: loadAction,
    saveAction: saveAction
  };
}; // --- legacy methods ---

/**
 * @deprecated replaced by enablePreferencesFromApi
 */


var usePreferencesFromApi = function usePreferencesFromApi(loadAction, saveAction) {
  return enablePreferencesFromApi(loadAction, saveAction);
};
/**
 * @deprecated replaced by getPreferenceSourceOptions
 */


var getPreferenceOptions = function getPreferenceOptions() {
  return getPreferenceSourceOptions();
};
/**
 * @deprecated replaced by getPreferenceModuleOptions
 */


var getPreferenceStoreProvider = function getPreferenceStoreProvider() {
  return getPreferenceModuleOptions().preferenceStoreProvider;
};
/**
 * @deprecated replaced by setPreferenceModuleOptions
 */


var setPreferenceStoreProvider = function setPreferenceStoreProvider(provider) {
  return setPreferenceModuleOptions({
    preferenceStoreProvider: provider
  });
};

export { enablePreferencesFromApi, enablePreferencesFromDeviceStorage, getPreferenceDefaults, getPreferenceModuleOptions, getPreferenceOptions, getPreferenceSource, getPreferenceSourceOptions, getPreferenceStoreProvider, setPreferenceDefaults, setPreferenceModuleOptions, setPreferenceStoreProvider, usePreferencesFromApi };
